import { render } from "./inbox-check-card.vue?vue&type=template&id=61b9e7fe"
import script from "./inbox-check-card.vue?vue&type=script&lang=js"
export * from "./inbox-check-card.vue?vue&type=script&lang=js"

import "./inbox-check-card.vue?vue&type=style&index=0&id=61b9e7fe&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__